// @flow

export const RECEIVE_AUTHENTICATED_USER = '@@fc-authenticated-user/RECEIVE_AUTHENTICATED_USER'
